import { AolItemBM, PortLogAolItemBM } from '../types/BusinessModel/AolItemBM';
import { NoonReportTypeEnum } from '../types/ViewModel/AolEnums';
import { AolItem, ErrorEvent, PortLogAolItem } from '../types/ViewModel/AolItem';
import { getDateFromISO, getDurationFromTimespan } from 'odfjell-date-time-utils/dateTimeUtils';
import { CargoTankTemperatureFactory } from './CargoTankTemperatureFactory';
import { FuelRobDataFactory } from './FuelRobDataFactory';

export class PortLogAolItemFactory {
    public create(data: PortLogAolItemBM): PortLogAolItem {
        return new PortLogAolItem(
            getDateFromISO(data.startTimeLocalTime),
            getDateFromISO(data.stopTimeLocalTime),
            data.noonReportType,
            data.imosPortCallId,
            data.isValid,
            data.errorEvents as ErrorEvent[]
        );
    }

    public createList(data: PortLogAolItemBM[]) {
        return data.map((h) => this.create(h));
    }
}

export class AolItemFactory {
    private portLogAolItemFactory = new PortLogAolItemFactory();
    private cargoTankTemperatureFactory = new CargoTankTemperatureFactory();
    private fuelRobDataFactory = new FuelRobDataFactory();

    public create(data: AolItemBM): AolItem {
        return new AolItem(
            this.portLogAolItemFactory.create(data.portLogAolItem),
            getDurationFromTimespan(data.dryDockingTime),
            getDurationFromTimespan(data.loadingTimes),
            getDurationFromTimespan(data.unloadingTimes),
            getDurationFromTimespan(data.shiftingMooringTime),
            getDurationFromTimespan(data.idleTime),
            getDurationFromTimespan(data.anchorageTime),
            getDurationFromTimespan(data.steamingForTankCleaningTime),
            getDurationFromTimespan(data.canalTransitTime),
            getDurationFromTimespan(data.tankCleaningTime),

            getDurationFromTimespan(data.operationalTargetSpeedTime),
            getDurationFromTimespan(data.operationalTargetConsumptionTime),
            getDurationFromTimespan(data.operationalNonTargetTime),
            getDurationFromTimespan(data.operationalAwaitingOrdersOrDriftingTime),
            getDurationFromTimespan(data.operationalTankPreparationTime),

            getDurationFromTimespan(data.navigationalEcaZoneTime),
            getDurationFromTimespan(data.navigationalCasualtyAndSarTime),
            getDurationFromTimespan(data.navigationalHighRiskAreaTime),
            getDurationFromTimespan(data.navigationalPilotManeuveringTime),
            getDurationFromTimespan(data.navigationalRiverPortManeuveringTime),
            getDurationFromTimespan(data.navigationalSafetyManeuveringTime),
            getDurationFromTimespan(data.navigationalStormShelteringTime),
            getDurationFromTimespan(data.navigationalTrafficManeuveringTime),
            getDurationFromTimespan(data.navigationalCasualtyAndSarDrillTime),

            getDurationFromTimespan(data.technicalAuxiliarySystemFailureTime),
            getDurationFromTimespan(data.technicalFuelQualityIssueTime),
            getDurationFromTimespan(data.technicalPropulsionSystemFailureTime),
            getDurationFromTimespan(data.technicalOtherTechnicalIssueTime),

            data.portDescription ? data.portDescription.toUpperCase() : '',
            data.voyageNumber,
            data.lastPortVisits,
            data.fuelRobDatas ? this.fuelRobDataFactory.createList(data.fuelRobDatas) : null,
            data.cargoTankTemperatures ? this.cargoTankTemperatureFactory.createList(data.cargoTankTemperatures) : null,
            data.cargoOnBoard,
            data.timeZoneChangeHours,
            data.portLogAolItem.noonReportType !== NoonReportTypeEnum.Sea ? data.dstOffsetHours : 0
        );
    }

    public createList(data: AolItemBM[]) {
        return data.map((h) => this.create(h));
    }
}
